<div class="panelContent">
	@if (!loadingExports) {
		<div [class.collapsed]="exportOptionsCollapsed" class="exportOptionsContainer">
			<div (click)="exportOptionsCollapsed = !exportOptionsCollapsed" class="exportSettingsTxt" mat-ripple>
				<div class="txt">
					{{ T.EXPORT_SETTINGS_TEXT | translate }}
				</div>
				<div class="toggleExportSettingsOpen">
					<button color="accent" mat-icon-button>
						<sim-animated-material-icon
							[trigger]="!exportOptionsCollapsed"
							[endIcon]="{fontSet: 'fad', fontIcon: 'fa-chevron-up'}"
							[startIcon]="{
								fontSet: 'fad',
								fontIcon: 'fa-chevron-down',
								themeColor: 'accent',
							}"
							class="toggleIndicator"
						/>
					</button>
				</div>
			</div>
			<div class="exportConfigSettingsCon">
				<mat-tab-group
					(selectedTabChange)="matTabChanged($event)"
					[(selectedIndex)]="selectedMatTabIndex"
					[mat-stretch-tabs]="false"
					class="custom-tab-group"
					color="accent"
				>
					<mat-tab label="{{ T.RECORDINGS_EXPORT_DIALOG_OPTION_VIDEO_ONLY | translate }}">
						<div class="exportVideoMix exportTogglerCon">
							<div class="exportTogglerAndOptionsCon">
								<div class="infoTextForExportOption">
									{{ T.RECORDINGS_EXPORT_DIALOG_OPTION_VIDEO_ONLY_INFO_TXT | translate }}
								</div>
							</div>
						</div>
						<div class="selectResolutionSelection">
							<mat-radio-group
								[(ngModel)]="config.resolution"
								aria-labelledby="example-radio-group-label"
								class="example-radio-group"
							>
								@for (resolution of resolutions; track resolution) {
									<mat-radio-button [value]="resolution.value" class="example-radio-button">
										{{ resolution.displayText }}
									</mat-radio-button>
								}
							</mat-radio-group>
						</div>
					</mat-tab>
					<mat-tab label="{{ T.RECORDINGS_EXPORT_DIALOG_OPTION_RAW_FILES | translate }}">
						<div class="exportRaw exportTogglerCon">
							<div class="exportTogglerAndOptionsCon">
								<div class="infoTextForExportOption">
									{{ T.RECORDINGS_EXPORT_DIALOG_OPTION_RAW_FILES_INFO_TXT | translate }}
								</div>
							</div>
						</div>
					</mat-tab>
					<mat-tab label="{{ T.RECORDINGS_EXPORT_DIALOG_ONLY_EXCEL | translate }}" />
				</mat-tab-group>
				<div class="exportTogglerAndOptionsCon">
					<div style="display: flex; flex-direction: column">
						@if (hasLicenseModule(Modules.UserManagment)) {
							<mat-checkbox [(ngModel)]="config.participants" class="checkbox" color="accent">
								{{ T.RECORDINGS_EXPORT_DIALOG_PARTICIPANTS | translate }}
							</mat-checkbox>
						}
						<mat-checkbox [(ngModel)]="config.annotations" class="checkbox" color="accent">
							{{ T.RECORDINGS_EXPORT_DIALOG_ANNOTATIONS | translate }}
						</mat-checkbox>
						@if (hasLicenseModule(Modules.Checklists)) {
							<mat-checkbox [(ngModel)]="config.checklists" class="checkbox" color="accent">
								{{ T.RECORDINGS_EXPORT_DIALOG_CHECKLISTS | translate }}
							</mat-checkbox>
						}
						@if (hasLicenseModule(Modules.Assessments)) {
							<mat-checkbox [(ngModel)]="config.assessments" class="checkbox" color="accent">
								{{ T.RECORDINGS_EXPORT_DIALOG_ASSESSMENTS | translate }}
							</mat-checkbox>
						}
					</div>
				</div>
				<mat-divider class="toggleOptionsDivider" />
				<div class="startExportBtn">
					@if (scenarioRecordingId) {
						<button (click)="startExport()" [disabled]="startingExport" class="exportBtn" color="accent" mat-raised-button>
							@if (startingExport) {
								<i class="fa-spinner-third fad fa-spin" style="margin-right: 10px"></i>
							}
							{{ T.SCENARIO_ARCHIVE_PLAYER_EXPORT_BUTTON | translate }}
						</button>
					}
					@if (scenarioRecordingIdList && scenarioRecordingIdList.length > 0) {
						<button
							(click)="startExportByList()"
							[disabled]="startingExport"
							class="exportBtn"
							color="accent"
							mat-raised-button
						>
							@if (startingExport) {
								<i class="fa-spinner-third fad fa-spin" style="margin-right: 10px"></i>
							}
							{{ T.SCENARIO_ARCHIVE_PLAYER_EXPORT_BUTTON | translate }}
						</button>
					}
					@if (scenarioEventId && !scenarioEventIdList) {
						<button (click)="startEventExport()" [disabled]="startingExport" class="exportBtn" color="accent" mat-raised-button>
							@if (startingExport) {
								<i class="fa-spinner-third fad fa-spin" style="margin-right: 10px"></i>
							}
							{{ T.SCENARIO_ARCHIVE_PLAYER_EXPORT_BUTTON | translate }}
						</button>
					}
					@if (scenarioEventIdList && scenarioEventIdList.length > 0) {
						<button
							(click)="startEventListExport()"
							[disabled]="startingExport"
							class="exportBtn"
							color="accent"
							mat-raised-button
						>
							@if (startingExport) {
								<i class="fa-spinner-third fad fa-spin" style="margin-right: 10px"></i>
							}
							{{ T.SCENARIO_ARCHIVE_PLAYER_EXPORT_BUTTON | translate }}
						</button>
					}
					@if (assessmentIds) {
						<button
							(click)="startAssessmentsExport()"
							[disabled]="startingExport"
							class="exportBtn"
							color="accent"
							mat-raised-button
						>
							@if (startingExport) {
								<i class="fa-spinner-third fad fa-spin" style="margin-right: 10px"></i>
							}
							{{ T.SCENARIO_ARCHIVE_PLAYER_EXPORT_BUTTON | translate }}
						</button>
					}
				</div>
			</div>
		</div>
	}

	<sim-component-loading-container
		[isLoading]="loadingExports"
		[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
		loadingIcon="fad fa-download"
	/>

	@if (exportsForScenarioRecordingWrapper?.all?.length <= 0 && !loadingExports && exportOptionsCollapsed) {
		<div class="noExportsCon">
			<div class="noExportsIcon">
				<i class="fad fa-download fa-4x"></i>
			</div>
			<div class="noExprotsTxt">
				{{ T.EXPORT_NONE_FOUND | translate }}
			</div>
		</div>
	}

	@if (exportsForScenarioRecordingWrapper?.all?.length > 0) {
		<div [@listStagger]="exportsForScenarioRecordingWrapper?.all?.length" class="exportsContainer">
			@for (exportInfo of exportsForScenarioRecordingWrapper?.all; track TrackByMethods.trackById($index, exportInfo)) {
				@if (exportInfo.visualState !== ExportVisualState.Dismissed) {
					<div class="export">
						@let scenarioRecording = exportInfo.scenarioRecordingId | getScenarioRecordingById | async;
						<div class="exportDate date">
							@if (scenarioRecording) {
								{{ scenarioRecording.start | date: (T.DATE_FORMAT_LONG_DAY | translate) :'': translate.currentLang }}
								|
								{{ scenarioRecording.start | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
								-
								{{ scenarioRecording.end | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
								| {{ scenarioRecording.recordingTimeMs | minsec }},
								<div class="nameOfScenario">
									{{ scenarioRecording?.scenario?.name }}
								</div>
							}
						</div>
						<div class="exportInfoCon">
							<div class="resolutionInfo">
								@if (scenarioRecording != null) {
									{{ scenarioRecording?.name ?? "..." }}
									<br />
									{{
										scenarioRecording
											? (scenarioRecording.trainingSessionId | getTrainingSessionbyId | async)?.title
											: "..."
									}},
									{{ scenarioRecording ? (scenarioRecording.id | getEventByScenarioRecordingId | async)?.name : "..." }}
								}
							</div>
						</div>
						<div class="exportInfoCon">
							@if (exportInfo?.config?.exportType !== ExportType.ExcelOnly) {
								<div class="resolutionInfo">
									<mat-icon fontIcon="fa-desktop" fontSet="fad" />
									{{ T.RECORDINGS_EXPORT_PANEL_RESOLUTION | translate }} :
									{{ exportInfo?.config?.resolution }}
								</div>
							}
							<ng-container *ngVar="appliedExportOptions(exportInfo) as appliedOptions">
								@if (!!appliedOptions?.length) {
									<div class="exportInfoOptionsCon">
										@for (info of appliedOptions; track TrackByMethods.trackByName($index, info)) {
											<div class="exportInfoItem">
												<mat-icon fontIcon="fa-check" fontSet="fad" />
												{{ info.name }}
											</div>
										}
									</div>
								}
							</ng-container>
						</div>
						<mat-divider class="dividerToActions" />
						<div class="exportActions">
							<ng-container>
								@switch (exportInfo.visualState) {
									@case (ExportVisualState.Terminated) {
										<button (click)="dismissExport(exportInfo.id)" color="warn" mat-raised-button>
											<i class="fas fa-remove"></i>
											{{ T.SCENARIO_ARCHIVE_PLAYER_EXPORT_DISMISS | translate }}
										</button>
									}
									@case (ExportVisualState.Default) {}
								}
							</ng-container>
							@switch (exportInfo.exportState) {
								@case (ExportState.Finished) {
									<sim-button
										(onClick)="downloadExport(exportInfo.id)"
										[icon]="{
											fontSet: 'fad',
											fontIcon: 'fa-download',
										}"
										[label]="T.RECORDINGS_EXPORT_DIALOG_DOWNLOAD_TXT"
										color="accent"
									/>
									<button (click)="deleteExport(exportInfo)" color="warn" mat-icon-button style="margin-right: 20px">
										<mat-icon fontIcon="fa-trash-alt" fontSet="fad" inline />
									</button>
								}
								@case (ExportState.Exporting) {
									<button (click)="cancelExport(exportInfo.id)" color="accent" mat-icon-button>
										<mat-icon fontIcon="fa-times" fontSet="fad" inline />
									</button>
									<button (click)="pauseExport(exportInfo.id)" color="warn" mat-icon-button>
										<mat-icon fontIcon="fa-pause" fontSet="fad" inline />
									</button>
								}
								@case (ExportState.Paused) {
									<button (click)="cancelExport(exportInfo.id)" color="accent" mat-icon-button>
										<mat-icon fontIcon="fa-times" fontSet="fad" inline />
									</button>
									<button (click)="resumeExport(exportInfo.id)" color="warn" mat-icon-button>
										<mat-icon fontIcon="fa-play" fontSet="fad" inline />
									</button>
								}
								@case (ExportState.Idle) {
									<button (click)="cancelExport(exportInfo.id)" color="accent" mat-icon-button>
										<mat-icon fontIcon="fa-times" fontSet="fad" inline />
									</button>
								}
							}
							<div class="statusCon">
								@switch (exportInfo.exportState) {
									@case (ExportState.Canceling) {
										{{ T.RECORDINGS_EXPORT_PANEL_STATUS_CANCELLING | translate }}
									}
									@case (ExportState.Canceled) {
										{{ T.RECORDINGS_EXPORT_PANEL_STATUS_CANCELLED | translate }}
									}
									@case (ExportState.Finished) {
										{{ T.RECORDINGS_EXPORT_PANEL_STATUS_FINISHED | translate }}
									}
									@case (ExportState.Failed) {
										{{ T.RECORDINGS_EXPORT_PANEL_STATUS_FAILED | translate }}
									}
									@case (ExportState.Paused) {
										{{ T.RECORDINGS_EXPORT_PANEL_STATUS_PAUSED | translate }}
									}
									@case (ExportState.Idle) {
										{{ T.RECORDINGS_EXPORT_PANEL_STATUS_IDLE | translate }}
									}
									@case (ExportState.Exporting) {
										<mat-progress-bar
											[mode]="'determinate'"
											[value]="exportInfo.progress * 100 | round: 2"
											color="accent"
										/>
										<div class="statusTextForProgress">
											{{ T.RECORDINGS_EXPORT_PANEL_STATUS_EXPORTING | translate }}
											{{ exportInfo.progress * 100 | round: 2 }}
											%
										</div>
									}
								}
							</div>
						</div>
						<div class="exportStateCon">
							<div class="icon">
								@switch (exportInfo?.exportState) {
									@case (ExportState.Finished) {
										<i class="fad fa-2x fa-check accent"></i>
									}
									@case (ExportState.Canceled) {
										<i class="fad fa-2x fa-exclamation-triangle warn2"></i>
									}
									@case (ExportState.Canceling) {
										<i class="fad fa-2x fa-exclamation-triangle warn2"></i>
									}
									@case (ExportState.Failed) {
										<i class="fad fa-2x fa-exclamation-triangle warn"></i>
									}
									@case (ExportState.Exporting) {
										<div class="exporting">
											<i class="fad fa-download accent"></i>
										</div>
									}
									@case (ExportState.Canceled) {
										<div class="exporting">
											<i class="fad fa-spin fa-spinner-third accent"> </i>
										</div>
									}
								}
							</div>
						</div>
					</div>
				}
			}
		</div>
	}
</div>
